import React, { useEffect } from "react";
import "react-day-picker/lib/style.css";
import "./App.css";
import "./DarkMode.scss";
import { connect } from "react-redux";

import { setUser, setNullUser } from "./store/actions/authActions";
import "./config/firebase";
import { auth } from "./config/firebase";
import "./config/API";
import Routes from "./components/layouts/Routes";
import DeprecationBanner from "./components/layouts/DeprecationBanner";
import { QueryClient, QueryClientProvider } from "react-query";
import { GlobalProvider } from "./context";
import { CookiesProvider } from "react-cookie";
import { identifyUser, registerSuperProperties } from "./utils/mixpanel";
import { getUserDetailsFromCookie } from "./utils/getCookies";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const App = ({ setUser, authLoaded, setNullUser }) => {
  // Initialize user from cookie and Mixpanel on app load
  useEffect(() => {
    try {
      const user = getUserDetailsFromCookie();

      if (user) {
        // Populate Redux with user from cookie
        setUser({
          ...user,
          name: user.displayName || user.name,
        });

        // Identify user in Mixpanel
        identifyUser(user.id, {
          email: user.email,
          subscription_type: user.pplan !== 0 ? 'paid' : 'free',
          user_type: user.pplan !== 0 ? 'pagante' : 'não pagante'
        });

        // Set super properties that will be sent with every event
        registerSuperProperties({
          app_version: process.env.REACT_APP_VERSION || '1.0.0',
          environment: process.env.NODE_ENV || 'production',
          platform: 'web'
        });
      }
    } catch (error) {
      console.warn('Could not initialize Mixpanel user context:', error);
    }
  }, [setUser]);
  useEffect(() => {
    auth.onAuthStateChanged((newUser) => {
      if (!newUser) {
        // Só limpa se não houver cookie válido
        const cookieUser = getUserDetailsFromCookie();
        if (!cookieUser) {
          setNullUser();
        }
      }

      if (newUser) {
        // Só sobrescreve se for um login do Firebase (Google)
        // Objeto Firebase tem uid, mas não tem id
        if (newUser.uid && !newUser.id) {
          setUser(newUser, true);  // isFromLogin = true
        }
      }
    });
  }, [setNullUser, setUser]);

  if (!authLoaded) return null;

  return (
    <QueryClientProvider client={queryClient}>
      <GlobalProvider>
        <CookiesProvider>
          <div className="App">
            <Routes />
            <DeprecationBanner />
          </div>
        </CookiesProvider>
      </GlobalProvider>
    </QueryClientProvider>
  );
};

const mapStateToProps = (state) => ({
  authLoaded: state.firebase.auth.isLoaded,
});

export default connect(mapStateToProps, { setUser, setNullUser })(App);
